<template>
  <div>
    <label class="error--text">* เป็นข้อจำกัดของทาง Tiktok ที่ต้องเลือกตัวเลือกจากที่มีอยู่แล้ว</label>
    <v-simple-table style="width: 100%">
      <template v-slot:default>
        <thead>
            <tr>
                <th class="text-center" style="width: 50%">ตัวเลือกใน Aoo</th>
                <th class="text-center" style="width: 50%">ตัวเลือกใน Tiktok</th>
            </tr>
        </thead>
        <tbody>
          <tr
            v-for="(attribute, index) in aooAttributes"
            :key="'aoo_' + index"
          >
            <td class="text-center">
              <!-- Aoo's attributes section-->
              {{ attribute.name }}
            </td>
            <td class="text-center">
              <!-- Tiktok's attributes section-->
              <v-autocomplete
                v-model="$attrs.value[index]"
                outlined
                :items="tiktokAttributes"
                item-text="name"
                item-value="id"
                hide-details="auto"
                dense
                :disabled="$store.getters['app/GET_APP_MODE'] == 'read'"
                :rules="[validators.required]"
              >
              </v-autocomplete>
            </td>
          </tr>
        </tbody>
      </template>
    </v-simple-table>
  </div>
</template>
<script>
import { required } from '@core/utils/validation'
export default {
  props: ['aooAttributes', 'tiktokAttributes'],
  data() {
    return {
      validators: {
        required,
      },
    }
  },
  watch: {
    /*
    tiktokAttributes(value) {
      if (!value) return

      const aooAttributes = this.aooAttributes

      if (aooAttributes.length == 1) return this.$emit('input', [this.getTiktokAttributeByAoo(aooAttributes[0].name)])

      if (aooAttributes.length == 2)
        return this.$emit('input', [
          this.getTiktokAttributeByAoo(aooAttributes[0].name),
          this.getTiktokAttributeByAoo(aooAttributes[1].name),
        ])
    },
    */
    aooAttributes(value) {
      if (!value) return

      if (value.length == 1) return this.$emit('input', [this.getTiktokAttributeByAoo(value[0].name)])

      if (value.length == 2)
        return this.$emit('input', [
          this.getTiktokAttributeByAoo(value[0].name),
          this.getTiktokAttributeByAoo(value[1].name),
        ])
    },
  },
  methods: {
    getTiktokAttributeByAoo(aooAttributeText) {
      return this.tiktokAttributes.find(attribute => attribute.name == aooAttributeText)
    },
  },
}
</script>
